import { Component } from '@angular/core';

@Component({
  selector: 'app-otd-page',
  template: `
    <router-outlet></router-outlet>
  `
})
export class OtdPageComponent {}
